"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _contactEnrichment = require("./store/contactEnrichment/contactEnrichment.actions");

var _contactEnrichment2 = require("./store/contactEnrichment/contactEnrichment.selector");

var _FlowSectionLoader = _interopRequireDefault(require("./components/FlowSectionLoader/FlowSectionLoader"));

var _recipient = require("./store/recipient/recipient.actions");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing;
  return {
    wrapper: {
      flexWrap: 'nowrap',
      height: 'calc(100% - 80px)',
      padding: spacing(2)
    }
  };
});

var ContactEnrichmentModule = function ContactEnrichmentModule(_ref2) {
  var enrichmentId = _ref2.enrichmentId,
      onEnrichmentFinished = _ref2.onEnrichmentFinished,
      _ref2$contact = _ref2.contact,
      firstName = _ref2$contact.firstName,
      lastName = _ref2$contact.lastName;
  var classes = useStyles();
  var dispatch = (0, _reactRedux.useDispatch)();
  var isEnrichmentFinished = (0, _reactRedux.useSelector)(_contactEnrichment2.getIsEnrichmentFinished);
  var isEnrichmentRequestFailed = (0, _reactRedux.useSelector)(_contactEnrichment2.getIsEnrichmentRequestFailed);
  (0, _react.useEffect)(function () {
    dispatch((0, _contactEnrichment.researchContactEnrichment)(enrichmentId));
    return function () {
      dispatch((0, _recipient.giftCreateRecipientReset)());
      dispatch((0, _contactEnrichment.cancelContactEnrichment)());
    };
  }, [dispatch, enrichmentId]);
  (0, _react.useEffect)(function () {
    if (isEnrichmentFinished) {
      onEnrichmentFinished();
    }
  }, [onEnrichmentFinished, isEnrichmentFinished]);
  (0, _react.useEffect)(function () {
    if (isEnrichmentRequestFailed) {
      onEnrichmentFinished();
    }
  }, [isEnrichmentRequestFailed, onEnrichmentFinished]);
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    className: classes.wrapper,
    container: true,
    justifyContent: "space-between",
    direction: "column"
  }, !isEnrichmentFinished && /*#__PURE__*/_react.default.createElement(_FlowSectionLoader.default, null, "Give us a second while we gather information on ", firstName, " ", lastName, "\u2026"));
};

ContactEnrichmentModule.propTypes = {
  enrichmentId: _propTypes.default.number.isRequired,
  onEnrichmentFinished: _propTypes.default.func.isRequired,
  contact: _propTypes.default.shape({
    firstName: _propTypes.default.string,
    lastName: _propTypes.default.string,
    position: _propTypes.default.string,
    email: _propTypes.default.string
  }).isRequired
};
var _default = ContactEnrichmentModule;
exports.default = _default;